import Box from '@material-ui/core/Box';
import useLayout from '../../styles/layout'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import {reserveRoutes} from '../../router/routeConfig'
import { useLocation } from 'react-router-dom'
import _ from 'lodash'
import { SelectInput, TextInput, DateInput, RadioInput } from '../../components/common/components'
import { setFormValue, getReserveDate, getReserveTime, setOptionLoading,loadPreviousVaccineData   } from '../../actions'
import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import ProgressBar from '../../components/ProgressBar'
import CircularProgress from '@material-ui/core/CircularProgress';
import { doPost } from '../../utils/AjaxRequests'
import { apiPrefixUrl } from '../../utils/connection'

const resetReserveDate = (dispatch)=>{
    dispatch(setFormValue({
        field: 'reserveDate',
        value: ''
    }))
    dispatch(getReserveDate())
}

const resetReserveTime = (dispatch)=>{
    dispatch(setFormValue({
        field: 'reserveTimeId',
        value: ''
    }))
    dispatch(getReserveTime())
}


export default function VaccineChoice() {

    const layoutClasses = useLayout()

    const location = useLocation();

    const idx = _.findIndex(reserveRoutes, (o) => o.path === location.pathname)

    const option = (useSelector(state => state.get("option"))).toJS()

    const form = (useSelector(state => state.get("form"))).toJS()

    const dispatch = useDispatch()

    let history = useHistory();

    const handlechange = useCallback((field, value) => {

        const preForm = _.cloneDeep(form)

        const inputValue = field === "PAT_IDNO"?value.toUpperCase():value

        dispatch(setFormValue({
            field,
            value:inputValue
        }))

    }, [dispatch, form])


    const handleNextClick = () => {
        if (!form.VACC_ID) {
            Swal.fire("請選擇疫苗種類", "", "error")
            return
        }

        history.push('/first_step')
    }

    if(option.config.length === 0){
        return <div>loading...</div>
    }

    return <Box className={layoutClasses.page}>
        <Helmet>
            <title>{reserveRoutes[idx].name}</title>
        </Helmet>
        <ProgressBar />       
        <Paper
            elevation={3}
            square
            className={layoutClasses.paper}
        >
            <Typography variant="subtitle1" gutterBottom align="center">
                {reserveRoutes[idx].name}
            </Typography>

            <SelectInput
                label="疫苗種類"
                field="VACC_ID"
                value={form.VACC_ID}
                setValue={handlechange}
                options={JSON.stringify(option.config)}
            />        

            {option.loading ?
                <div style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0,0,0,0.3)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <CircularProgress size={200} />
                </div> : null}
        </Paper>
        {option.loading ? null :
            <Button
                variant="contained"
                color="primary"
                style={{ margin: "30px auto" }}
                onClick={() => { handleNextClick() }}
            >
                下一步
            </Button>}
    </Box>
}